import styles from "./styles/upgrade-to-download.module.scss";
import Link from "next/link";
import React from "react";
import { LicenseName } from "@/data/license.data";

interface UpgradeToDownloadProps {
  license: LicenseName;
  isLoading: boolean;
}

const UpgradeToDownload = ({ license, isLoading }: UpgradeToDownloadProps) => {
  if (license === "Trial" && !isLoading) {
    return (
      <div className={styles.trial_wrapper}>
        <p>Upgrade to download your audio conversions.</p>
        <Link href={"/pricing"} className={styles.upgrade_text}>
          Upgrade Now
        </Link>
      </div>
    );
  }
};
export default UpgradeToDownload;
